import React from 'react';
import { Link } from 'react-router-dom';

const CATEGORIES = [
  { name: 'Intelligence Économique', img: '/images/cat-intelligence.jpg', icon: 'fa-magnifying-glass-chart' },
  { name: 'Politique & Gouvernance', img: '/images/cat-politique.jpg', icon: 'fa-landmark' },
  { name: 'Finance & Investissement', img: '/images/cat-finance.jpg', icon: 'fa-coins' },
  { name: 'Commerce & Industrie', img: '/images/cat-commerce.jpg', icon: 'fa-ship' },
  { name: 'Énergie & Ressources', img: '/images/cat-energie.jpg', icon: 'fa-bolt' },
  { name: 'Technologie & Innovation', img: '/images/cat-tech.jpg', icon: 'fa-microchip' },
  { name: 'Agriculture & Développement rural', img: '/images/cat-agriculture.jpg', icon: 'fa-wheat-awn' },
];

const Categories = () => {
  return (
    <section className="section bg-alt">
      <div className="container">
        <span className="section-kicker">Thématiques</span>
        <div className="section-head">
          <h2 className="section-title">Nos domaines de recherche</h2>
        </div>
        <p className="section-lead">
          Une couverture thématique complète des enjeux économiques stratégiques du continent.
        </p>

        <div className="grid grid-4">
          {CATEGORIES.map((cat) => (
            <Link
              key={cat.name}
              to={`/publications?category=${encodeURIComponent(cat.name)}`}
              className="card"
            >
              <div className="card-media">
                <img src={cat.img} alt={cat.name} loading="lazy" />
              </div>
              <div className="card-body">
                <h3>
                  <i className={`fa-solid ${cat.icon}`} style={{ color: '#b8862f', marginRight: '8px' }} />
                  {cat.name}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;